// extracted by mini-css-extract-plugin
module.exports = {"bar":"ScrollingBar_bar__9S_xD","scrolling":"ScrollingBar_scrolling__3a78b"};